import React from 'react';
import { useParams } from 'react-router';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getDefectTypes, loadApplicationPpr } from './api';

export const path = '/ppr/application/:id';
export const getPath = (applicationId: string) => `/ppr/application/${applicationId}`;

const PageApplicationPpr: React.FC = (props) => {
  const { id } = useParams<{ id: string; areaId: string }>();

  const ApplicationPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      application: () => loadApplicationPpr(+id),
      defectTypes: getDefectTypes,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <ApplicationPpr {...props} />;
};

export default PageApplicationPpr;
